<template>
  <v-app>
    <!-- ================= SEARCH PANEL ================= -->
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Search Form
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-form @submit.prevent="loadReport">
                  <v-row class="px-2 pt-4">
                    <v-col cols="12" md="2">
                      <v-autocomplete
                        v-model="buyer_id.value.value"
                        :items="getCustomerMapList"
                        :item-title="item => `${item.customer?.company_name ?? ''} - ${item.customer?.code ?? ''}`"
                        :item-value="item => item.customer?.id"
                        variant="outlined"
                        density="compact"
                        clearable
                      >
                        <template #label>
                          Buyer
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        variant="outlined"
                        density="compact"
                        v-model="from_date.value.value"
                        prepend-icon=""
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        variant="outlined"
                        density="compact"
                        v-model="to_date.value.value"
                        prepend-icon=""
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-btn
                        type="submit"
                        color="primary"
                        :loading="loading"
                      >
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <!-- ================= REPORT TABLE ================= -->
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="reportPanel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                expand-icon="mdi-chevron-down"
              >
                Order Summary Report
              </v-expansion-panel-title>

              <v-expansion-panel-text>

                <div class="d-flex align-center flex-column mt-3">
                    <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="success"
                            @click="exportToCSV" disabled="">
                            CSV
                        </v-btn>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="primary"
                            @click="exportToExcel">
                            EXCEL
                        </v-btn>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="red"
                            @click="exportToPDF" disabled="">
                            PDF
                        </v-btn>
                    </v-btn-group>
                </div>

                <div style="overflow-y: auto; white-space: nowrap;">
                  <table class="order-table mt-6" style="width: 100%; border-collapse: collapse;">
                    <thead>
                      <tr>
                        <th rowspan="2">SL</th>
                        <th colspan="9">Buyer Order</th>
                        <th colspan="7">Textile Order</th>
                        <th colspan="7"> Production Order</th>
                      </tr>
                      <tr>
                        
                        <th>Buyer</th>
                        <th>Order No</th>
                        <th>Order Date</th>
                        <th>Order Received Date</th>
                        <th>Order Delivery Date</th>
                        <th>Style</th>
                        <th>Color</th>
                        <th>Order Qty</th>
                        <th>PO Order Qty</th>
                        <th>Dyeing Order Qty</th>
                        <th>Dyeing Req Qty (KG)</th>
                        <th>Yarn Delivery</th>
                        <th>Yarn Receive</th>
                        <th>Rec Fabric Knit</th>
                        <th>Dyeing Delivery</th>
                        <th>Dyeing Receive</th>
                        <th>Cut Qty</th>
                        <th>Sewing In Qty</th>
                        <th>Sewing Out Qty</th>
                        <th>QC Check Qty</th>
                        <th>QC Pass Qty</th>
                        <th>QC Failed Qty</th>
                        <th>Finished Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(order, oIndex) in reportData" :key="oIndex">
                        <template v-for="(item, sIndex) in Object.values(order.items)" :key="sIndex">
                          <template v-for="(bd, cIndex) in Object.values(item.breakdown)" :key="cIndex">
                            <tr>
                              <td
                                v-if="sIndex === 0 && cIndex === 0"
                                :rowspan="Object.values(order.items).reduce((t, i) => t + Object.keys(i.breakdown).length, 0)"
                              >
                                {{ oIndex + 1 }}
                              </td>

                              <td
                                v-if="sIndex === 0 && cIndex === 0"
                                :rowspan="Object.values(order.items).reduce((t, i) => t + Object.keys(i.breakdown).length, 0)"
                              >
                                {{ order.buyer?.name }}
                              </td>

                              <td
                                v-if="sIndex === 0 && cIndex === 0"
                                :rowspan="Object.values(order.items).reduce((t, i) => t + Object.keys(i.breakdown).length, 0)"
                              >
                                {{ order.code }}
                              </td>

                              <td
                                v-if="sIndex === 0 && cIndex === 0"
                                :rowspan="Object.values(order.items).reduce((t, i) => t + Object.keys(i.breakdown).length, 0)"
                              >
                                {{ order.order_date }}
                              </td>

                              <td
                                v-if="sIndex === 0 && cIndex === 0"
                                :rowspan="Object.values(order.items).reduce((t, i) => t + Object.keys(i.breakdown).length, 0)"
                              >
                                {{ order.order_receive_date }}
                              </td>

                              <td
                                v-if="sIndex === 0 && cIndex === 0"
                                :rowspan="Object.values(order.items).reduce((t, i) => t + Object.keys(i.breakdown).length, 0)"
                              >
                                {{ order.delivery_date }}
                              </td>

                              <td
                                v-if="cIndex === 0"
                                :rowspan="Object.keys(item.breakdown).length"
                              >
                                {{ item.style?.code }} - {{ item.style?.name }}
                              </td>

                              <td>{{ bd.color?.name }}</td>
                              <td>{{ bd.by_order_quantity }}</td>
                              <td>{{ bd.po_order_quantity }}</td>
                              <td>{{ bd.dy_order_qty_pcs }}</td>
                              <td>{{ bd.dy_req_qty_kg }}</td>
                              <td>{{ bd.dy_yarn_delivery }}</td>
                              <td>{{ bd.dy_yarn_receive }}</td>
                              <td>{{ bd.dy_rec_fabric_knit }}</td>
                              <td>{{ bd.dy_dye_delivery }}</td>
                              <td>{{ bd.dy_dye_receive }}</td>
                              <td>{{ bd.ct_qty }}</td>
                              <td>{{ bd.si_sewn_qty }}</td>
                              <td>{{ bd.so_output_qty }}</td>
                              <td>{{ bd.qc_checked_qty ?? 0 }}</td>
                              <td>{{ bd.qc_passed_qty ?? 0 }}</td>
                              <td>{{ bd.qc_failed_qty ?? 0 }}</td>
                              <td>{{ bd.fi_finished_qty ?? 0 }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>
                    </tbody>
                  </table>
                </div>

              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import Axios from "axios";
import { prefix } from "@/store/api";
import formattedDate from "@/plugins/dateFormatter";

export default {
  name: "FinishingOutputReport",

  data() {
    return {
      panel: [0],
      reportPanel: [0],
      loading: false,
      search: "",
      reportData: [],

      headers: [
        { title: "#", key: "index" },
        { title: "Buyer Name", key: "buyer_name" },
        { title: "Order No & Fabric Type", key: "order_no_and_fabric_type" },
        { title: "Yarn Count", key: "yarn_count" },
        { title: "Color", key: "color.name" },
        { title: "Qty (PCS)", key: "order_qty" },
        { title: "Req Qty (KG)", key: "req_qty_kg" },
        { title: "Yarn Delivery", key: "yarn_delivery" },
        { title: "Rcvd Fabric Knit", key: "rec_fabric_knit" },
        { title: "Dye Delivery", key: "dye_delivery" },
        { title: "Dye Receive", key: "dye_receive" },
        { title: "Receive Yarn", key: "yarn_receive" },
        { title: "Balance", key: "balance" },
      ],
    };
  },

  setup() {
    const { handleSubmit } = useForm({
      validationSchema: yup.object({
        buyer_id: yup.number().nullable(),
        from_date: yup.date().nullable(),
        to_date: yup.date().nullable(),
      }),
    });

    const buyer_id = useField("buyer_id");
    const from_date = useField("from_date");
    const to_date = useField("to_date");

    return {
      buyer_id,
      from_date,
      to_date,
      handleSubmit,
    };
  },

  computed: {
    getCustomerMapList() {
      return this.$store.getters.getCustomerMapList || [];
    },
  },

  methods: {
    loadReport() {
      this.loading = true;

      const params = {};
      if (this.buyer_id.value.value)
        params.buyer_id = this.buyer_id.value.value;
      if (this.from_date.value.value)
        params.from_date = formattedDate(this.from_date.value.value);
      if (this.to_date.value.value)
        params.to_date = formattedDate(this.to_date.value.value);

      Axios.get(`${prefix}bhp/reports/order/summary`, { params })
        .then(res => {
          this.reportData = res.data || [];
        })
        .finally(() => (this.loading = false));
    },
    exportToExcel() {
      if (!this.reportData || !this.reportData.length) {
          toast.info("No data to export");
          return;
      }

      const rows = [];

      // ===== HEADER ROW 1 (GROUP HEADER) =====
      rows.push([
          "SL",
          "Buyer Order", "", "", "", "", "", "", "",
          "Textile Order", "", "", "", "", "", "",
          "Production Order", "", "", "", "", "", ""
      ]);

      // ===== HEADER ROW 2 (COLUMN HEADER) =====
      rows.push([
          "SL",
          "Buyer",
          "Order No",
          "Order Date",
          "Order Received Date",
          "Order Delivery Date",
          "Style",
          "Color",
          "Order Qty",
          "PO Order Qty",
          "Dyeing Order Qty",
          "Dyeing Req Qty (KG)",
          "Yarn Delivery",
          "Yarn Receive",
          "Rec Fabric Knit",
          "Dyeing Delivery",
          "Dyeing Receive",
          "Cut Qty",
          "Sewing In Qty",
          "Sewing Out Qty",
          "QC Check Qty",
          "QC Pass Qty",
          "QC Failed Qty",
          "Finished Qty",
      ]);

      let sl = 1;

      // ===== DATA =====
      this.reportData.forEach(order => {
          Object.values(order.items || {}).forEach(item => {
              Object.values(item.breakdown || {}).forEach(bd => {
                  rows.push([
                      sl++,
                      order.buyer?.name || "",
                      order.code || "",
                      order.order_date || "",
                      order.order_receive_date || "",
                      order.delivery_date || "",
                      `${item.style?.code || ""} - ${item.style?.name || ""}`,
                      bd.color?.name || "",
                      bd.by_order_quantity ?? 0,
                      bd.po_order_quantity ?? 0,
                      bd.dy_order_qty_pcs ?? 0,
                      bd.dy_req_qty_kg ?? 0,
                      bd.dy_yarn_delivery ?? 0,
                      bd.dy_yarn_receive ?? 0,
                      bd.dy_rec_fabric_knit ?? 0,
                      bd.dy_dye_delivery ?? 0,
                      bd.dy_dye_receive ?? 0,
                      bd.ct_qty ?? 0,
                      bd.si_sewn_qty ?? 0,
                      bd.so_output_qty ?? 0,
                      bd.qc_checked_qty ?? 0,
                      bd.qc_passed_qty ?? 0,
                      bd.qc_failed_qty ?? 0,
                      bd.fi_finished_qty ?? 0,
                  ]);
              });
          });
      });

      this.$exportTableToExcel(
          rows,
          "Order Summary Report",
          "order_summary_report_" + this.$fileDate()
      );
    },

  },
};
</script>

<style scoped>
.order-table { width:100%; border-collapse:collapse; font-size:13px; margin-bottom:24px; }
.panel-header { font-weight: 600;}
.order-table th {
  padding: 10px 10px;
  background-color: #cfd8dc;
  border: 1px solid #000;
}
.order-table td {
  padding: 10px 10px;
  border: 1px solid #000;
  text-align: center;
}
</style>
